export default "__VITE_ASSET__36ce59de__"